import React from 'react';

import { Box, Container, Typography } from '@material-ui/core';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import LockIcon from '../../assets/icons/LockIcon';
import { CustomButton } from '../UI/CustomButton';
import useStyles from './styles';

interface JoinNowProps {
  isLoggedIn: boolean;
  description?: string;
  btnCaption?: string;
  classes?: {
    container?: string;
    wrapper?: string;
    lockText?: string;
    description?: string;
    lockIcon?: string;
    link?: string;
  };
}

const JoinNowBlock: React.FC<JoinNowProps> = ({
  isLoggedIn,
  classes,
  description,
  btnCaption,
  ...rest
}) => {
  const defaultClasses = useStyles();
  const { t } = useTranslation();

  return (
    <Container
      className={classes?.wrapper ? classes.wrapper : ''}
      data-testid={rest['data-testid']}
    >
      <Box className={cx(defaultClasses.container, classes?.container && classes.container)}>
        <LockIcon className={cx(defaultClasses.lockIcon, classes?.lockIcon)} />
        <Typography variant="h2" className={cx(defaultClasses.lockText, classes?.lockText)}>
          {t(isLoggedIn ? 'page.video.subscribeToWatch' : 'page.video.joinToWatch')}
        </Typography>
        <Typography className={cx(defaultClasses.description, classes?.description)}>
          {description || t('page.video.accessFreeTrial')}
        </Typography>
        <Link
          to="/pricing"
          data-testid="joinNowLink"
          className={cx(defaultClasses.link, classes?.link)}
        >
          <CustomButton>{btnCaption || t('button.startFreeTrial')}</CustomButton>
        </Link>
      </Box>
    </Container>
  );
};

export default JoinNowBlock;
